<template>
  <div class="setPrintData">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      class="contactsForm"
    >
      <!-- <div class="setPrintDataTitle">合作单位信息</div> -->
      <div class="setPrintDataContent">
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="标题："
              prop="elaluateModel"
              label-width="110px"
            >
              <el-input
                class="contactsInput"
                v-model="dataForm.scoreTemplate"
                maxlength="12"
                placeholder="请输入标题"
                readonly
              ></el-input>
              <!-- <el-select
                v-model="dataForm.scoreTemplate"
                filterable
                default-first-option
                placeholder="请选择"
                disabled
              >
                <el-option label="劳务合作单位评价表" value="1"></el-option>
                <el-option label="设备物资合作单位评价表" value="2"></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--法人姓名-->
            <el-form-item label="填报单位：">
              <el-input
                class="contactsInput"
                v-model="ruleForm.applyDeptNamePrint"
                maxlength="12"
                placeholder="填报单位"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <!--填报时间-->
            <el-form-item label="填报时间">
              <!-- <el-input
                class="contactsInput"
                v-model="dataForm.duptDeptCommentTime"
                maxlength="60"
                placeholder="请输入时间"
                readonly
              ></el-input> -->
              <el-date-picker
                v-model="dataForm.duptDeptCommentTime"
                type="date"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
                disabled
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <!--公司名称-->
            <el-form-item label="合作单位名称：">
              <el-input
                class="contactsInput"
                v-model="dataForm.supplierName"
                maxlength="60"
                placeholder="请输入合作单位名称"
                readonly
              ></el-input>
            </el-form-item>

            <!-- <div class="phoneStatement">请按照营业执照上登记的完整名称填写</div> -->
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <!--法人姓名-->
            <el-form-item label="负责人：">
              <el-input
                class="contactsInput"
                v-model="dataForm.legalPerson"
                maxlength="12"
                placeholder="请输入负责人"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <!--注册资金-->
            <el-form-item label="注册资金：">
              <el-input
                class="contactsInput"
                v-model="dataForm.registeredCapital"
                maxlength="20"
                placeholder="请输入注册资金："
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <!--资质等级-->
            <el-form-item label="资质等级：">
              <el-input
                class="contactsInput"
                v-model="dataForm.qualificationLevel"
                maxlength="12"
                placeholder="请输入资质等级："
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="合作单位简介" prop="supplierDescPrint">
              <el-input
                type="textarea"
                :rows="6"
                placeholder="请输入合作单位简介"
                v-model="ruleForm.supplierDescPrint"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="bottomBtn">
      <el-button type="primary" @click="submitBtn('ruleForm')">保 存</el-button>
      <el-button type="primary" @click="printData('ruleForm')">打 印</el-button>
      <el-button type="info" @click="close">关 闭</el-button>
    </div>
    <labelPrint
      :visible.sync="printVisible"
      :formData="printDatas"
      :tableData="dataForm.tableData"
      v-if="printVisible"
    >
    </labelPrint>
  </div>
</template>

<script>
import {
  getSupplierEvaluateDetailService, //查询供应商评分详情
  savePrintEvaluateInfo, //保存打印评价表信息
} from "@/services/supplierMagServices";
import labelPrint from "./labelPrint"; //打印工程量清单

export default {
  name: "setPrintData",
  props: {
    id: {
      type: Number,
      default: 0,
    },
    dataForm: {
      type: Object,
      default: {},
    },
  },
  components: {
    labelPrint,
  },
  data() {
    return {
      printVisible: false,
      printDatas: {},
      searchForm: {
        contractId: null,
        projectId: null,
        scoreYear: null,
        supplierId: null,
      },
      ruleForm: {
        duptDeptCommentTime: null, //
        applyDeptNamePrint: this.dataForm.projectDeptName,
        supplierDescPrint: "", //合作单位简介
      },

      rules: {
        projectDeptName: [
          { required: true, message: "请填写填报单位", trigger: "blur" },
        ],
        supplierDescPrint: [
          { required: true, message: "请输入合作单位简介", trigger: "blur" },
        ],
      },
      isShopNameBool: false,
    };
  },
  watch: {
    'dataForm.contractId': {
      handler: function (newVal) {
        if (newVal) {
          this.getSupplierEvaluateDetail();
        }
      },
      immediate: true,
    },
  },
  methods: {
    //获取一条生产部门评价信息
    getSupplierEvaluateDetail() {
      this.searchForm.contractId = this.dataForm.contractId;
      this.searchForm.projectId = this.dataForm.projectId;
      this.searchForm.scoreYear = this.dataForm.scoreYear;
      this.searchForm.supplierId = this.dataForm.supplierId;
      getSupplierEvaluateDetailService(this.searchForm)
        .then((res) => {
          if (res.code == 10000000) {
            this.ruleForm = res.data;
            // this.ruleForm.legalPerson = this.dataForm.legalPerson;
            // this.ruleForm.supplierName = this.dataForm.ruleForm.supplierName;
            this.ruleForm.applyDeptNamePrint = this.ruleForm.applyDeptNamePrint||res.data.projectDeptName;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },

    close() {
      (this.ruleForm = {
        id: "", //id
        duptDeptCommentTime: null, //
        applyDeptNamePrint: "",
        supplierDescPrint: "", //合作单位简介
      }),
        this.$emit("close");
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    //提交
    submitBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let obj = { ...this.searchForm, ...this.ruleForm };
          savePrintEvaluateInfo(obj).then((res) => {
            if (res.code == 10000000) {
              this.$refs.ruleForm.clearValidate();
              this.$emit("close");
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    printData() {
      this.$refs["ruleForm"].validate((valid) => {
        if (!valid) return;
        this.printDatas = { ...this.dataForm,
          applyDeptNamePrint:this.ruleForm.applyDeptNamePrint,
          supplierDescPrint:this.ruleForm.supplierDescPrint

         };
        this.printVisible = true;
        // this.$emit("handlePrint", {
        // 	formData: this.formData,
        // 	approveList: this.approveList,
        // });
      });
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-table .cell {
  white-space: pre-line;
}
/deep/.el-dialog__body {
  padding: 10px 20px;
}

/deep/.el-popover {
  padding: 24px;
}

.setPrintData {
  width: 100%;
}
@media only screen and(max-width:1680px) {
  .setPrintData {
    width: 100%;
  }
}
.setPrintData {
  background: rgba(255, 255, 255, 1);
  .el-form-item {
    width: 100%;
  }
  /deep/.cell .el-form-item__content {
    margin-left: 10px !important;
  }
  /deep/.el-form-item {
    margin-bottom: 20px;
  }

  .el-checkbox {
    line-height: 40px;
  }

  .el-textarea {
    min-width: 0px !important;
  }
  .el-cascader {
    width: 100%;
  }

  .el-form-item__content {
    width: calc(100% - 110px);
    line-height: 20px;

    .el-input {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
  }
  .bottomBtn {
    // border-top: 1px solid #e6e6e6;
    width: 90%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    margin-bottom: 20px;
  }
  .setPrintDataTitle {
    height: 44px;
    padding-left: 24px;
    box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
    border-radius: 2px 2px 0px 0px;
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 44px;
    text-align: left;
  }
  .setPrintDataContent {
    padding: 14px 8px;
  }
  /deep/.daterangePicker {
    width: 255px;
    height: 32px;
    .el-input__icon {
      display: flex;
      align-items: center;
    }
    .el-range-separator {
      display: flex;
      align-items: center;
    }
  }
}
</style>
